'use strict';

var privatePropertyAccessor = require('../internal/privatePropertyAccessor');

module.exports = privatePropertyAccessor('utc');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/_utc.js
// module id = 28
// module chunks = 0